import { IIdologyProgressResponseEntity } from '../../model/api/identity-verification/idology-progress-response.entity.interface';
import { IIdologyProgress } from '../../model/models/identity-verification/idology-progress-response.interface';
import { FormControlMapper } from '../formbuilder/formcontrol-mapper';

export class IdentityVerificationMapper {
  static fromIdologyResponseEntity(entity: IIdologyProgressResponseEntity): IIdologyProgress {
    const model: IIdologyProgress = {
      sessionId: entity.model.sessionId,
      status: entity.model.status,
      questions: !entity.model.questions ? null : entity.model.questions.map(q => {
        return {
          id: q.id,
          text: q.text,
          category: q.category,
          chosenAnswerText: q.chosenAnswerText,
          possibleAnswers: !q.possibleAnswers ? null : q.possibleAnswers.map(a => {
            return {
              id: a.id,
              text: a.text,
            }
          }),
        }
      }),
    };

    // Apparently this response can come back with any number of different forms, or no form at all!
    // It's up to us to determine this.
    if (entity.formData && entity.formData.VerifyIdentityTaxIdForm) {
      model.formFields = FormControlMapper.mapControls(entity.formData.VerifyIdentityTaxIdForm.formFields, 'VerifyIdentityTaxIdForm', entity.model);
    }
    else if (entity.formData && entity.formData.VerifyIdentityQuizForm) {
      model.formFields = FormControlMapper.mapControls(entity.formData.VerifyIdentityQuizForm.formFields, 'VerifyIdentityQuizForm', entity.model);
    }

    return model;
  }
}



// WEBPACK FOOTER //
// ./src/providers/identity-verification/identity-verification-mapper.ts